export default {
  methods: {
   async render_left(data,width) {
    //颜色总数
    var xzdata =  data.map(v=>v.storeSaleNum).reverse();
    var tips = data.map(v=>v.bigModel).reverse();
    var yzdata = []
    tips.forEach((v,index)=>{
      yzdata.push(index+1)
    })
    var yzdata = yzdata.reverse();
    var yMax = 500
    var dataShadow = []
     // 将实际值显示在阴影柱的label 位置 需要对label 进行处理
    //  for (var i = 0; i < xzdata.length; i++) {
    //   dataShadow.push({
    //       value: yMax,
    //       name: xzdata[i]
    //   });
    // }
      let option = {
        color:['#FF8A02'],
        // title: {
        //   text: '',
        //   top: 10
        // },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          confine: true
        },
        legend: {
        },
        grid: {
          left: '3%',
          right: '6%',
          bottom:25,
          top: 6,
          containLabel: true
        },
        formatter: params => {
          // console.log(params);
          let str = ""
          str = `${tips[params[0].dataIndex]||0}<br/>${params[0].marker}<span style="inline-block;  text-algin:right; float:right; font-weight:800;">${params[0].data}</span><br/>`
          return str
        },
        // dataZoom: {
        //   type: 'inside',
        //   start: 0,
        //   end: data.allCategoryName.length<20 ? 100 : 24
        // },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          position: 'top',
          axisLine:{
              lineStyle:{
                color:"#fff",
                width:1,
              }
            },
            splitLine:{
              show:false
            }
      },
      yAxis: [
        {
          type: "category",
          offset: 0,

          axisLine: {
            //这是x轴文字颜色
            lineStyle: {
              color: "#000",
              // color: 'rgb(135,139,160)',
            },
          },
          data: yzdata,
          axisLabel:{
            interval:0,//横轴信息全部显示
          },
          axisPointer: {
            type: "shadow",
          },
          axisTick: {
            show: false,
          },
          splitLine:{
            show:false
          },
          axisLine:{       //y轴
            show:false
  
          },
        },

          ],
      series: [
      //   { // For shadow
      //     type: 'bar',
      //     itemStyle: {
      //         color: 'rgba(0,0,0,0.05)',
      //         barBorderRadius: 8
      //     },
      //     barWidth: 12,
      //     barGap: '-100%', // 设置背景的关键代码
      //     barCategoryGap: '40%',
      //     label: {
      //         show: true,
      //         position: 'right',
      //         color: 'FF8A02',
      //         formatter: function (params) {
      //             return params.name
      //         }
      //     },
      //     data: dataShadow,
      //     animation: false
      // },
        
          {
              name: '',
              type: 'bar',
              yAxisIndex: 0,
              data: xzdata,  
              barWidth: 12,
              barCategoryGap: "10%",
              label: {   //设置柱状图上显示  对应值
                  show: true,
                  position:'right',
                  // position: ['100%','100%'],
                  color:'#FF8A02'
              },
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)',
                borderRadius: [8, 8, 8, 8]
              },
              
               itemStyle: {
                  normal: {
                      barBorderRadius: [8, 8, 8, 8] // 设置柱状图圆角（顺时针左上，右上，右下，左下）
                  },
                  
              },
          },
        //    { //背景灰框
        //     name: '白框',
        //     type: 'bar',
        //     yAxisIndex: 1,
        //     barGap: '-100%',//设置-100% 则表示灰色柱状图与红色柱状图重合
        //     data: xzdata,
        //     barWidth: 21,
        //     itemStyle: {
        //         normal: {
        //             color: '#DDDDDD',
        //             barBorderRadius:[100, 100, 100, 100],
        //         },
                
        //     },
        //     z: 1  // 设置维度越高这表示覆盖低的
        // },
      ]

      };
      let $instance = this.$echarts.init(this.$refs['overview']);
      $instance.setOption(option,true);
      if(width == 1920) {
        const autoHeight = yzdata.length * 36 + 55;
        $instance .resize({height: autoHeight})
      }
      
      
    }
  }
}